

class Dependencies{
	constructor(){
		var _request,
			_target,
			_loggerFactory
		;
		
		Object.defineProperty(this,'target',{
			get : function(){ return _target },
			set : function(target){ _target = target },
			enumerable: true 
		});		
		
		Object.defineProperty(this,'request',{
			get : function(){ return _request },
			set : function(request){ _request = request },
			enumerable: true 
		});
		
		Object.defineProperty(this,'loggerFactory',{
			get : function(){ return _loggerFactory },
			set : function(loggerFactory){ _loggerFactory = loggerFactory },
			enumerable: true 
		});		
	}
}

export var dependencies = new Dependencies();

